import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Subscription } from 'rxjs/Subscription';
import { FooterNavbarService } from 'services/connectors/footer-navbar.service';
import { EmissionService } from 'services/emission.service';
import { Constants } from 'config/constants';
import { SpinnerService } from 'services/spinner.service';
import { Observable } from 'rxjs/Rx';

@Component({
    selector: 'tpc-events-commute',
    templateUrl: './commute.component.html',
    styleUrls: ['./commute.component.css']
})
export class EventsCommuteComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    private countDefaultValue = 0;

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private spinner: SpinnerService) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    private createForm() {
        this._form = this.fb.group({
            carPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            carMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            trainPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            trainMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            busPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            busMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            taxiPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            taxiMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            ferryPeople: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
            ferryMile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999999),
                CustomValidators.digits]],
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    private next(): void {
        // let calculatorName = Constants.calculators.business;
        // let categoryName = 'commute';
        let calculatorNameIndividual = Constants.calculators.individual;
        let calculatorNameEvents = Constants.calculators.events;
        let publicTransitCategoryName = 'publicTransit';
        let carEventsCategoryName = 'car';

        let data = {
            carPeople: this.getFV('carPeople'),
            carMile: this.getFV('carMile'),
            trainPeople: this.getFV('trainPeople'),
            trainMile: this.getFV('trainMile'),
            busPeople: this.getFV('busPeople'),
            busMile: this.getFV('busMile'),
            taxiPeople: this.getFV('taxiPeople'),
            taxiMile: this.getFV('taxiMile'),
            ferryPeople: this.getFV('ferryPeople'),
            ferryMile: this.getFV('ferryMile')
        };

        // Hardcoded until backend will create separate API call
        let dataForPublicTransit = this.prepareDataForPublicTransit(data);
        let dataForCarEvents = {
            mile: data.carMile,
            count: data.carPeople
        };


        if ((!!+data.carPeople && !!+data.carMile) || (!!+data.trainPeople && !!+data.trainMile) ||
            (!!+data.busPeople && !!+data.busMile) || (!!+data.taxiPeople && !!+data.taxiMile) ||
            (!!+data.ferryPeople && !!+data.ferryMile)) {
            this.spinner.show();
            let publicTransitRequest = this.emissionService.getEmissionValue(dataForPublicTransit, calculatorNameIndividual, publicTransitCategoryName);
            let carEventRequest = this.emissionService.getEmissionValue(dataForCarEvents, calculatorNameEvents, carEventsCategoryName);

            Observable.forkJoin([publicTransitRequest, carEventRequest]).subscribe(
                response => {
                    let firstResponseData = response[0].body[0].input[0];
                    let secondResponseData = response[1].body[0].input[0];
                    let emissionSum = firstResponseData.emmission + secondResponseData.emmission;
                    this.emissionService.getTotalPrice(emissionSum).subscribe(
                        result => {
                            let totalSum = {
                                emission: emissionSum,
                                emissionTrees: result[0].emissionTrees,
                                DollarAmt: result[0].DollarAmt,
                                DollarAmtMonthly: result[0].DollarAmtMonthly
                            };
                            this.emissionService.setEmission({
                                category: Constants.categories.events.commute,
                                emission: totalSum
                            });
                            this.footerService.skip();
                            this.spinner.hide();
                        }
                    );
                });
            // this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            //     response => {
            //         let input = response.body[0].input[0];
            //         this.emissionService.setEmission({
            //             category: Constants.categories.events.commute,
            //             emission: {
            //                 emission: input.emmission,
            //                 emissionTrees: input.emissionTrees,
            //                 DollarAmt: input.DollarAmt,
            //                 DollarAmtMonthly: input.DollarAmtMonthly
            //             }
            //         });
            //
            //         this.footerService.skip();
            //         this.spinner.hide();
            //     }
            // );
        } else {
            this.emissionService.setEmission({
                category: Constants.categories.events.commute,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });

            this.footerService.skip();
        }
    }

    public getFV(param) {
        return this.form.get(param).value;
    }

    private prepareDataForPublicTransit(data) {
        let params = {
            trainMile: 0,
            busMile: 0,
            taxiMile: 0,
            ferryMile: 0,
            trainInterval: 'year',
            busInterval: 'year',
            taxiInterval: 'year',
            ferryInterval: 'year',
        };

        // miles quantity multiply by people count
        params.trainMile = data.trainMile * data.trainPeople;
        params.busMile = data.busMile * data.busPeople;
        params.taxiMile = data.taxiMile * data.taxiPeople;
        params.ferryMile = data.ferryMile * data.ferryPeople;

        return params;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/commute/commute.component.ts